import React, { Component } from 'react';

class Forgot extends Component {
    render() {
        return (
            <div>
                adasd
            </div>
        );
    }
}

export default Forgot;